<template>
	<div class="root">
		<vipMeetingHeader/>
		<div class="container">
			<div class="info">
				<div class="appointment-info">
					<div class="order-status">
						<div class="icon"><img src="@/assets/order/success.png"></div>
						<div class="middle">
							<div class="status">已预约</div>
							<div class="tip">房间将为您在预约时间内保留，请放心上门。</div>
							<div class="orderno">订单编号: 56457875488</div>
						</div>
						<div class="button">再次预约</div>
					</div>
					<div class="detail">
						<h3>预约信息</h3>
						<div class="appointment-item" v-for='i in 3'>
							<div class="room-name">会议室1（大）2021-08-08</div>
							<div class="appointment-date">
								<div class="start">
									<div>到店时间</div>
									<div class="time">10:00</div>
								</div>
								<div class="duration">
									1小时
								</div>
								<div class="end">
									<div>离开时间</div>
									<div class="time">11:00</div>
								</div>
							</div>
						</div>
						<div class="phone">
							<div class="label">联系方式</div>
							<div class="input">17717573369</div>
						</div>
						<div class="remark">
							<div class="label">特殊要求</div>
							<Input :autosize='{minRows: 4}' maxlength='300' type='textarea' placeholder="如:布置会议室安排投影仪等" v-model='remark'></Input>
						</div>
						<div class="invoice">
							<div class="label">发票 <div><Checkbox class='checkbox' v-model="single">需要发票</Checkbox></div></div>
						</div>
					</div>
				</div>
				<div class="price-info">
					<h3>价格信息</h3>
					<div class="price-item">
						<div class="name">会议室1（大）× 1小时</div>
						<div class="price">￥100</div>
					</div>
					<div class="price-item">
						<div class="name">会议室1（大）× 1小时</div>
						<div class="price">￥200</div>
					</div>
					<div class="total">
						<h3>支付总额</h3>
						<div class="price">￥200</div>
					</div>
					<div class="additional">
						<div class="name">一次性按摩工具</div>
						<div class="buy-tool">
							<div class='tool-btn' type='text'><Icon type="md-remove" /></div>
							<div class="number">0</div>
							<div class='tool-btn' type='text'><Icon type="md-add" /></div>
						</div>
						<Button type='primary' class="button">购买</Button>
					</div>
					<div class="tips">
						<p style="color:#B176C5;margin-top: 20px;font-size: 20px;">限时取消</p>
						<p style="margin-top: 10px;">可在预约时间前半小时取消，并自动退款;半小时内无法再取消退款。</p>
						<div class="timeline">
							<Timeline>
						        <TimelineItem color="#B176C5">
						        	<Icon size='30' type="ios-time-outline" slot="dot"/>
						            <p style='color:#B176C5'>无责取消</p>
						            <p style='color:#B176C5' class="content">2021-08-08 09:30前</p>
						        </TimelineItem>
						        <TimelineItem>
						        	<p>不可取消</p>
						            <p class="content">2021-08-08 10:00后</p>
						        </TimelineItem>
						    </Timeline>
						    <div class="button">取消预约</div>
						</div>
						
					</div>
				</div>
			</div>
			<div class="bottom">
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import vipMeetingHeader from '@/components/header/vipMeetingHeader'
	export default {
		data() {
			return {
				phone:'',
				remark:'',
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			vipMeetingHeader,
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){

			},
			goPay(){
				this.$router.push('/vipmeeting/payment')
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.root {
		display:block;
		background-color: #eee;
	}
	.container {
		background-color: #eee;
		padding-top:1rem;
		margin:auto;
		max-width: 1400px;
	}
	.info {
		display:flex;
		flex-direction: row;
		h3 {
			@include fontSize($font-size-30);
			font-weight: normal;
			margin-bottom: 20px;
		}
		.appointment-info {
			flex:2;
			.order-status {
				display:flex;
				align-items: center;
				margin-bottom: 20px;
				.icon {
					width:150px;
					height:150px;
					background-color: $green;
					display:flex;
					align-items: center;
					justify-content: center;
					border-radius: 75px;
					img {
						width:80px;
					}
				}
				.middle {
					flex:1;
					margin-left: 20px;
					@include fontSize($font-size-16);
				}
				.status {
					color: $green;
					font-weight: bold;
					@include fontSize($font-size-20);
				}
				.tip,.orderno {
					margin-top: 10px;
				}
				.button {
					align-self: flex-end;
					cursor: pointer;
					@include fontSize($font-size-16);
					width:120px;
					color: $theme-color;
					border:1px solid $theme-color;
					text-align: center;
					border-radius: 20px;
					padding:5px 0;
				}
			}
			.detail,.order-status {
				background-color: white;
				padding: 20px;
				border-radius: 20px;
			}
			.appointment-item {
				margin-bottom: 20px;
			}
			.room-name {
				@include fontSize($font-size-20);
				margin-bottom: 10px;
			}
			.appointment-date {
				display:flex;
				align-items: center;
				.start,.end {
					@include fontSize($font-size-16);
					.time {
						margin-top: 5px;
						width:100%;
					}
				}
				.duration {
					margin:0 40px;
					@include fontSize($font-size-16);
				}
			}
			.phone,.remark,.invoice {
				margin-top: 20px;
				.label {
					@include fontSize($font-size-20);
					margin-bottom: 10px;
					display:flex;
					align-items: center;
					.checkbox {
						margin-left: 20px;
					}
				}
				.input {
					border:none;
					outline:none;
					@include fontSize($font-size-16);
				}
			}
			
		}
		.price-info {
			flex:1;
			margin-left: 20px;
			padding: 20px;
			background-color: white;
			border-radius: 20px;
			.price-item {
				display:flex;
				justify-content: space-between;
				@include fontSize($font-size-16);
				margin-bottom: 10px;
				.price {
					font-weight: bold;
				}
			}
			.additional {
				display:flex;
				align-items: center;
				margin-top: 20px;
				padding:20px 0;
				justify-content: space-between;
				border-top: 1px dashed #aaa;
				border-bottom: 1px dashed #aaa;
				padding-bottom: 60px;
				position: relative;
				.name {
					color:$theme-color;
					@include fontSize($font-size-16);
				}
				.button {
					position: absolute;
					bottom:10px;
					right: 0;
					width:120px;
					border-radius: 20px;
				}
				.buy-tool {
					display:flex;
					align-items: center;
					.number {
						box-shadow: 3px 8px 20px 0px rgba(0,0,0,0.1);
						text-align: center;
						width:40px;
						height:40px;
						display:flex;
						align-items: center;
						justify-content: center;
						margin:0 10px;
						border-radius: 20px;
						color:$theme-color;
						font-weight: bold;
						@include fontSize($font-size-20);
					}
					.tool-btn {
						cursor: pointer;
						display:flex;
						align-items: center;
						justify-content: center;
						width:30px;
						height:30px;
						border:1px solid $theme-color;
						color:$theme-color;
						font-size: 20px;
					}
				}
			}
			.total {
				display:flex;
				align-items: center;
				margin-top: 20px;
				justify-content: space-between;
				h3 {
					@include fontSize($font-size-20);
					margin-bottom: 0;
				}
				.price {
					font-weight: bold;
					color:red;
					@include fontSize($font-size-24);
				}
			}
			.tips {
				margin-top: 20px;
				.timeline {
					display:flex;
					justify-content: space-between;
					margin-top: 30px;
					.button {
						align-self:flex-end;
						cursor: pointer;
						@include fontSize($font-size-16);
						width:120px;
						color: $theme-color;
						border:1px solid $theme-color;
						text-align: center;
						border-radius: 20px;
						padding:5px 0;
					}
				}
			}
		}
	}
	.bottom {
		margin-bottom: 20px;
	}
</style>